import { ItemListMapper } from '../../infrastructure/utils/implementation/item-list.mapper';
import { IOperatorsDTO } from '../../api/operators.dao';

export class OperatorItemsMapper extends ItemListMapper<IOperatorsDTO> {
    public static create(initialOperatorList: IOperatorsDTO[]): OperatorItemsMapper {
        return new OperatorItemsMapper(initialOperatorList || []);
    }

    public getAddedOperatorsToList(list: IOperatorsDTO[]): IOperatorsDTO[] {
        return super.getItemsAddedToList(list, this.initialList);
    }
    public getRemovedOperatorsFromList(list: IOperatorsDTO[]): IOperatorsDTO[] {
        return super.getItemsRemovedFromList(list, this.initialList);
    }
    public getUpdatedOperatorsInList(list: IOperatorsDTO[]): IOperatorsDTO[] {
        const updatedOperators = super.getItemsUpdatedInListByKey(list, this.initialList, this.updateKey);

        return this.assignIdsToOperators(updatedOperators);
    }

    private constructor(private readonly initialList: IOperatorsDTO[]) {
        super('email');
    }

    private readonly updateKey = 'operatorRole';

    private assignIdsToOperators(list: IOperatorsDTO[]): IOperatorsDTO[] {
        return list.map(item => {
            const id = this.findInitialOperatorIdByEmail(item.email);
            return id !== null ? { ...item, operatorId: id } : item;
        });
    }
    private findInitialOperatorIdByEmail(email: string): number | null {
        return this.initialList.find(item => item['email'] === email)?.operatorId ?? null;
    }
}
